export default __webpack_public_path__ + "static/media/linkedInLogo.06e27fd1.svg";